import React, { useEffect } from "react";
import styles from "./raiseTicketPage.module.scss";
import { Outlet } from "react-router-dom";
import NavTabs from "../../components/mui/tabs/NavTab";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";


const tabs = [
  {
    id: "1",
    title: "Pending",
    link: "/raiseTicket",
  },
  {
    id: "2",
    title: "Resolved",
    link: "/raiseTicket/completed",
  },
];

const RaiseTicketPage = () => {



  return (
    <div className={styles.container}>
      <StatusCard leftContent="Raise Ticket" />

      <div className={styles.top}>
        <NavTabs data={tabs} variant="fullWidth" />
      </div>

      <div className={styles.bottom}>
        <Outlet />
      </div>
    </div>
  );
};

export default RaiseTicketPage;
